import { render, staticRenderFns } from "./PrescriberLayout.vue?vue&type=template&id=06b9cf11&scoped=true&"
import script from "./PrescriberLayout.vue?vue&type=script&lang=ts&"
export * from "./PrescriberLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriberLayout.vue?vue&type=style&index=0&id=06b9cf11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9cf11",
  null
  
)

export default component.exports